export { ArrowCaretLeftSm4 } from "./ArrowCaretLeftSm4";
